export default __webpack_public_path__ + "static/media/login-tributei.252ffb98.svg";